import request from '@/utils/request'
import store from '../vuex/store'
// 查询所有
export function getAllDicts() {
  request(`/v1/omsDictData/getAll`, {
    method: 'GET',
  }).then(response => {
    if (response.success == '1') {
      let map = response.obj

      // this.apkIdOptions = map.apk_id;
      store.commit('dictsOptions', map)
    } else {
      console.log(response.msg)
    }
    return response;
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js